/* eslint-disable @typescript-eslint/no-explicit-any */
export function isIOS() {
	const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera || undefined;
	return /iPad|iPhone|iPod/.test(userAgent)
}